import {ReactComponent as CloseIcon} from '../../../images/Close-btn.svg'
import AccessCodeTable from './AccessCodeTable';

interface props{
    show:boolean,
    onClose:()=>void;
    codes: { [key: string]: any }[];
}
const AuthModal:React.FC<props>=({codes,show,onClose})=> {
 
if(!show)return <></>
console.log(codes)

  return (
    <div className='bg-[rgba(25,25,25,0.25)] fixed top-0 left-0 w-full h-full flex items-center justify-center' style={{zIndex:'1000'}} onClick={onClose}>
        <div className={`bg-white py-[36px] px-[54px] rounded-[20px] max-w-[95%] min-w-[70vw] lg:min-w-[50vw] overflow-auto max-h-[90%] h-fit relative `} onClick={(e)=>e.stopPropagation()}>
          <h1 className='font-semibold leading-none text-center text-[32px] md:text-[45px] tracking-[1px] mb-[36px] md:mb-[65px]'>Access Codes</h1>
          <div>
            <CloseIcon className='absolute right-[20px] md:right-[45px] top-[28px] md:top-[50px] cursor-pointer' onClick={onClose}/>
            <AccessCodeTable data={codes.map((item) => ({
              "Access Code":item.code,
              "Status": item.activated.toLocaleString(),
                }))}/>
          </div>  
        </div>
    </div>
  )
}

export default AuthModal